import { ErrorMessage, Field } from "formik";

export default function FormField({
  as = "input",
  type = "text",
  label,
  name,
  options,
  required,
  multiple,
  help,
  error,
  requiredLabel,
  labelProps,
  contentProps,
  containerProps,
  children,
  ...props
}) {
  const isGroup = !!options || !!children;
  const labelId = `form-field-${name}-label`;
  const fieldId = `form-field-${name}-field`;
  const containerAllProps = {
    className: `form-field form-field-${name} form-field--${as}${
      type ? "-" + type : ""
    } form-field--${required ? "required" : "optional"}`,
  };
  const labelAllProps = { id: labelId };
  const contentAllProps = { className: "form-field-content" };
  const fieldAllProps = { name, multiple, required };
  if (isGroup) {
    contentAllProps.role = "group";
    contentAllProps.ariaLabelledby = labelId;
  } else {
    labelAllProps.htmlFor = fieldId;
  }
  Object.assign(containerAllProps, containerProps || {});
  Object.assign(labelAllProps, labelProps || {});
  Object.assign(contentAllProps, contentProps || {});
  Object.assign(fieldAllProps, props || {});
  return (
    <div {...containerAllProps}>
      <label {...labelAllProps}>
        {label}
        {!!required && (
          <span className="form-field-required-label" aria-hidden="true">
            {requiredLabel || " *"}
          </span>
        )}
      </label>
      <div {...contentAllProps}>
        {Boolean(children) ? (
          children
        ) : Boolean(options) ? (
          as === "select" ? (
            <Field id={fieldId} as="select" {...fieldAllProps}>
              {!!fieldAllProps.placeholder && (
                <option>{fieldAllProps.placeholder}</option>
              )}
              {options.map(({ value, label }) => (
                <option value={value}>{label}</option>
              ))}
            </Field>
          ) : (
            <div className={`form-field-options form-field-options--${type}`}>
              {options.map(({ value, label }) => (
                <label
                  className={`form-field-option form-field-option--${type}`}
                >
                  <span className="form-field-option-field"></span>
                  <Field type="radio" value={value} {...fieldAllProps} />
                  <span className="form-field-option-label">{label}</span>
                </label>
              ))}
            </div>
          )
        ) : (
          <Field id={fieldId} as={as} type={type} {...fieldAllProps} />
        )}
      </div>
      {!!help && (
        <div className={`form-field-help`}>
          <p className={`form-field-help-message`}>{help}</p>
        </div>
      )}
      {!!error ? (
        <div className={`form-field-error`}>
          <p className={`form-field-error-message`}>{error}</p>
        </div>
      ) : (
        <ErrorMessage name={name}>
          {(message) => (
            <div className={`form-field-error`}>
              <p className={`form-field-error-message`}>{message}</p>
            </div>
          )}
        </ErrorMessage>
      )}
    </div>
  );
}
